// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3pbIY","signatureBlock":"Footer_signatureBlock__1KQRL","signature":"Footer_signature__1IXJt"};